import { render, staticRenderFns } from "./NosologyView.vue?vue&type=template&id=59378c05"
import script from "./NosologyView.vue?vue&type=script&lang=js"
export * from "./NosologyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports